import React from 'react';
import Card from 'components/Card/Card';
import { EditImage } from 'components/EditImage/EditImage';
import { EditText, EditTextArea, EditDropDown, EditRichTextArea } from 'components/EditText/EditText';
import { functionality, type } from '../../../../lib/homeHub';

const HomeHubItem = ({ editing, homeHub, onEdit, onToggle, categoriesKB }) => {
    const getTypeOptions = () => {
        const options = [...type];
        options.unshift({ id: 'select', name: 'Select' });

        return options;
    };

    const getFunctionalityOptions = () => {
        const options = [...functionality, ...categoriesKB];
        options.unshift({ id: 'select', name: 'Select' });

        return options;
    };

    return (
        <Card title="Home Hub Item" editing={editing ? '1' : undefined} onToggle={onToggle}>
            <div className="group-edit-outer">
                <div className="group-edit-image-outer me-4">
                    <EditImage
                        editing={editing ? '1' : undefined}
                        imageid={homeHub.image_id}
                        onChange={(imageId) => onEdit({ image_id: imageId })}
                        maxHeight={200}
                        maxWidth={200}
                    />
                </div>
                <div className="group-edit-text-outer">
                    <EditText
                        label="Title"
                        editing={editing ? '1' : undefined}
                        onChange={(text) => onEdit({ title: text })}
                        value={homeHub.title}
                    />
                    <EditTextArea
                        label="Subtitle"
                        editing={editing ? '1' : undefined}
                        onChange={(text) => onEdit({ subtitle: text })}
                        value={homeHub.subtitle}
                    />
                    <EditDropDown
                        className="mb-3"
                        label="Type  "
                        options={getTypeOptions()}
                        editing={editing ? '1' : undefined}
                        onChange={(id) => {
                            const data = type.filter((item) => item.id === id);
                            const value = data.length ? data[0].id : '';

                            onEdit({ type: value });
                        }}
                        value={homeHub.type}
                    />
                    {homeHub.type === 'content' && (
                        <EditRichTextArea
                            label="Content"
                            editing={editing ? '1' : undefined}
                            onChange={(text) => onEdit({ content: text })}
                            value={homeHub.content}
                        />
                    )}
                    {homeHub.type === 'functionality' && (
                        <EditDropDown
                            className="mb-3"
                            label="Functionality"
                            options={getFunctionalityOptions()}
                            editing={editing ? '1' : undefined}
                            onChange={(id) => {
                                const data = [...functionality, ...categoriesKB].filter((item) => item.id === id);
                                const value = data.length ? data[0].id : '';

                                onEdit({ functionality: value });
                            }}
                            value={homeHub.functionality}
                        />
                    )}
                    {homeHub.type === 'url' && (
                        <EditText
                            label="Link"
                            editing={editing ? '1' : undefined}
                            onChange={(text) => onEdit({ url: text })}
                            value={homeHub.url}
                        />
                    )}
                    <EditText
                        label="Order"
                        editing={editing ? '1' : undefined}
                        onChange={(text) => onEdit({ order: text })}
                        value={homeHub.order}
                        helpText="Sort order (Ascending: lower is higher, bigger is heavier, eg: 0, 1, 2, 5, 11, 12)"
                        type="number"
                    />
                </div>
            </div>
        </Card>
    );
};

export default HomeHubItem;
